import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from 'shared/store';

export const newsApi = createApi({
  reducerPath: 'newsApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['News', 'NewsById'],
  endpoints: (builder) => ({
    // Дублирование из features для скрытия ошибки, потом убрать
    getMe: builder.query({
      query: () => ({
        url: '',
      }),
    }),
  }),
});
